import { apiClient } from './client';
import { OrganizationResponse } from './organizations';

export interface UserResponse {
  id: number;
  email: string | null;
  full_name: string;
  active: boolean;
  confirmed: boolean;
  ref_id: string | null;
  speciality: string | null;
  force_reset_password: boolean;
  created_at: string;
  updated_at: string;
  roles?: string[];
}

export interface UsersListResponse {
  nodes: UserResponse[];
  total: number;
  page: number;
  per_page: number;
}

export interface AdminResponse {
  full_name: string;
  email: string | null;
}

export interface AdminsListResponse {
  nodes: AdminResponse[];
}

export interface CreateUserPayload {
  email: string;
  full_name: string;
  speciality?: string;
  ref_id?: string;
}

export interface UpdateUserPayload {
  full_name?: string;
  email?: string;
  active?: boolean;
  speciality?: string;
  ref_id?: string;
  role?: string;
}

export interface CurrentResponse {
  permissions: string[];
  organization: OrganizationResponse | null;
}

export interface MeResponse {
  id: number;
  email: string | null;
  full_name: string;
  active: boolean;
  ref_id: string | null;
  role: string | null;
  speciality: string | null;
  force_reset_password: boolean;
  current: CurrentResponse | null;
}

export const usersApi = {
  me: () => apiClient.get<MeResponse>('/api/users/me'),

  admins: () => apiClient.get<AdminsListResponse>('/api/users/admins'),

  list: (params?: { page?: number; per_page?: number; search?: string }) =>
    apiClient.get<UsersListResponse>('/api/users', { params }),

  get: (userId: number) => apiClient.get<UserResponse>(`/api/users/${userId}`),

  getByEmail: (email: string) =>
    apiClient.get<UsersListResponse>('/api/users', { params: { search: email, per_page: 1 } }),

  create: (data: CreateUserPayload, role: string) =>
    apiClient.post<UserResponse>('/api/users', data, { params: { role } }),

  update: (userId: number, data: UpdateUserPayload) =>
    apiClient.patch<UserResponse>(`/api/users/${userId}`, data),

  remove: (userId: number) => apiClient.delete(`/api/users/${userId}`),
};
